import { graphql } from "../generated";

export const FeaturesFlags = graphql(`
  query FeaturesFlags {
    featureFlags
      @rest(type: "RestFeatureFlag", path: "feature_flags", endpoint: "v3") {
      advancedAiPackage
      dashboardExtensionEnableRestrictedCompaniesAssetsPage
      disableFrontendTracking
      conversationIntelligenceCustomerProvisioning
      conversationCenterDisableSentiments
    }
  }
`);
